export const CREATE_DP_TEMPLATE = 'CREATE_DP_TEMPLATE'

export const UPDATE_DP_TEMPLATE = 'UPDATE_DP_TEMPLATE'
